import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { AfterViewInit, Component, ComponentRef, NgModule, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldDataUpsertOperationInterface } from '@vendasta/account-group';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { FieldHandler, FieldHandlerValidator } from '@vendasta/auxiliary-data-components';
import { CrmMultiStringAutocompleteComponent } from '../../../filters/definitions/dynamic-options/crm-multi-string-autocomplete/crm-multi-string-autocomplete.component';
import { DynamicEntryComponentCrmConfig } from '../../../filters/definitions/dynamic-options/dynamic-options';

export class TagsHandler implements FieldHandler {
  formControl: FormControl;
  component: ComponentRef<TagsComponent>;

  constructor(
    public fieldId: string,
    public name: string,
    public label: string,
    public value: string[],
    public description: string,
    public validators: FieldHandlerValidator[],
    public readOnly = false,
  ) {
    this.formControl = new FormControl(value);
    this.formControl.setValidators(validators.map((v) => v.validatorFn));
  }

  render(viewContainerRef: ViewContainerRef): void {
    viewContainerRef.clear();
    this.component = viewContainerRef.createComponent<TagsComponent>(TagsComponent);
    this.component.instance.config = { crmObjectType: '', fieldId: this.fieldId };
    this.component.instance.control = this.formControl;
    this.component.instance.label = this.label;
  }

  upsertOperation(): FieldDataUpsertOperationInterface {
    this.formControl.setValue(this.component.instance.control.value);

    if (this.formControl.value === null) {
      return {
        fieldDataId: this.fieldId,
        deleteValue: true,
      };
    }
    return {
      fieldDataId: this.fieldId,
      string: this.formControl.value,
    };
  }

  hasModification(): boolean {
    return this.formControl.dirty;
  }
}

@Component({
  styles: [``],
  template: ` <automata-crm-multi-string-autocomplete
    [initialValue]="control.value"
    [config]="config"
    [label]="label"
    #multiStringComponent
  ></automata-crm-multi-string-autocomplete>`,
  standalone: false,
})
export class TagsComponent implements AfterViewInit {
  @ViewChild('multiStringComponent') multiStringComponent: CrmMultiStringAutocompleteComponent;
  config: DynamicEntryComponentCrmConfig;
  label: string;
  control: FormControl;

  ngAfterViewInit(): void {
    this.multiStringComponent.selectedValue$.subscribe((value) => {
      this.control.setValue(value);
    });
  }
}

@NgModule({
  declarations: [TagsComponent],
  exports: [TagsComponent],
  imports: [
    CommonModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslateModule,
    GalaxyFormFieldModule,
    CrmMultiStringAutocompleteComponent,
  ],
})
export class NotYetSupportedComponentModule {}
